module.exports = __webpack_public_path__ + "img/Group 1280.6245489a.svg";